import { MutableRefObject, Ref, useRef } from "react";

export default <T>(ref: Ref<T>) => {
    const baseRef = useRef<T | null>(null);

    return (ref as MutableRefObject<T>) || baseRef;
};
